import { useRadio } from '@chakra-ui/react'
import React from 'react'
import { handleKeyDown } from './Accessibilty'

type InputProps = ReturnType<ReturnType<typeof useRadio>['getInputProps']>

export const RadioButton = React.forwardRef((inputProps: InputProps, ref: React.Ref<HTMLInputElement>) => {
  const onChange = inputProps.onChange as (event: React.FormEvent<HTMLInputElement>) => void

  return (
    <input
      {...inputProps}
      onChange={() => null}
      onClick={onChange}
      onKeyDown={handleKeyDown(onChange)}
      tabIndex={-1}
      ref={ref}
    />
  )
})
